export default {
  item: {},
  items: [],
  pagination: {},
  itemsHome: [],
  brands: [],
  priceRange: {},
  isFavorite: false
}
